import { render, staticRenderFns } from "./SiftActivity.vue?vue&type=template&id=a2a5a772&"
import script from "./SiftActivity.vue?vue&type=script&lang=js&"
export * from "./SiftActivity.vue?vue&type=script&lang=js&"
import style0 from "./SiftActivity.vue?vue&type=style&index=0&id=a2a5a772&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a5a772')) {
      api.createRecord('a2a5a772', component.options)
    } else {
      api.reload('a2a5a772', component.options)
    }
    module.hot.accept("./SiftActivity.vue?vue&type=template&id=a2a5a772&", function () {
      api.rerender('a2a5a772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/SiftActivity.vue"
export default component.exports